import { createSelector } from 'reselect';
import moment from 'moment';

export const Types = {
  GET_REQUEST: 'events/GET_REQUEST',
  GET_SUCCESS: 'events/GET_SUCCESS',
  GET_FAILURE: 'events/GET_FAILURE',

  GET_LIST_REQUEST: 'events/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'events/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'events/GET_LIST_FAILURE',

  CREATE_REQUEST: 'events/CREATE_REQUEST',
  CREATE_SUCCESS: 'events/CREATE_SUCCESS',
  CREATE_FAILURE: 'events/CREATE_FAILURE',

  UPDATE_REQUEST: 'events/UPDATE_REQUEST',
  UPDATE_SUCCESS: 'events/UPDATE_SUCCESS',
  UPDATE_FAILURE: 'events/UPDATE_FAILURE',

  GET_LOCAL_REQUEST: 'events/GET_LOCAL_REQUEST',
  GET_LOCAL_SUCCESS: 'events/GET_LOCAL_SUCCESS',
  GET_LOCAL_FAILURE: 'events/GET_LOCAL_FAILURE',

  GET_TYPES_REQUEST: 'events/GET_TYPES_REQUEST',
  GET_TYPES_SUCCESS: 'events/GET_TYPES_SUCCESS',
  GET_TYPES_FAILURE: 'events/GET_TYPES_FAILURE',

  GET_STORES_REQUEST: 'events/GET_STORES_REQUEST',
  GET_STORES_SUCCESS: 'events/GET_STORES_SUCCESS',
  GET_STORES_FAILURE: 'events/GET_STORES_FAILURE',

  GET_PASSIONS_REQUEST: 'events/GET_PASSIONS_REQUEST',
  GET_PASSIONS_SUCCESS: 'events/GET_PASSIONS_SUCCESS',
  GET_PASSIONS_FAIULRE: 'events/GET_PASSIONS_FAIULRE',

  GET_DIFFICULTIES_REQUEST: 'events/GET_DIFFICULTIES_REQUEST',
  GET_DIFFICULTIES_SUCCESS: 'events/GET_DIFFICULTIES_SUCCESS',
  GET_DIFFICULTIES_FAIULRE: 'events/GET_DIFFICULTIES_FAIULRE',

  GET_PLANS_REQUEST: 'events/GET_PLANS_REQUEST',
  GET_PLANS_SUCCESS: 'events/GET_PLANS_SUCCESS',
  GET_PLANS_FAILURE: 'events/GET_PLANS_FAILURE',

  APPROVE_REQUEST: 'events/APPROVE_REQUEST',
  APPROVE_SUCCESS: 'events/APPROVE_SUCCESS',
  APPROVE_FAILURE: 'events/APPROVE_FAILURE',

  REPPROVE_REQUEST: 'events/REPPROVE_REQUEST',
  REPPROVE_SUCCESS: 'events/REPPROVE_SUCCESS',
  REPPROVE_FAILURE: 'events/REPPROVE_FAILURE',

  INVITE_REQUEST: 'events/INVITE_REQUEST',
  INVITE_SUCCESS: 'events/INVITE_SUCCESS',
  INVITE_FAILURE: 'events/INVITE_FAILUTE',

  // DELETE_REQUEST: 'events/GET_REQUEST',
  // DELETE_SUCCESS: 'events/GET_SUCCESS',
  // DELETE_FAILURE: 'events/GET_FAILURE'
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  totals: 1,

  detail: {
    data: {},
    loading: true,
  },

  create: {
    loading: false,
  },

  update: {
    loading: false,
  },

  locals: {
    data: [],
    loading: true,
  },

  stores: {
    data: [],
    loading: true,
  },

  types: {
    data: [],
    loading: true,
  },

  passions: {
    data: [],
    loading: true,
  },

  difficulties: {
    data: [],
    loading: true,
  },

  plans: {
    data: [],
    loading: true,
  },

  approve: {
    loading: false,
  },

  repprove: {
    loading: false,
  },

  invite: {
    loading: false,
  },

  // delete: {
  //   loading: false,
  // },
};

export default function events(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload.event.data,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.events.data,
        page: action.payload.events.meta.current_page,
        totals: action.payload.events.meta.total_pages,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.CREATE_REQUEST:
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
        },
      };
    case Types.CREATE_SUCCESS:
    case Types.CREATE_FAILURE:
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
        },
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: true,
        },
      };
    case Types.UPDATE_SUCCESS:
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    case Types.GET_TYPES_REQUEST:
      return {
        ...state,
        types: {
          ...state.types,
          loading: true,
        },
      };
    case Types.GET_TYPES_SUCCESS:
      return {
        ...state,
        types: {
          ...state.types,
          data: action.payload.types.data,
          loading: false,
        },
      };
    case Types.GET_TYPES_FAILURE:
      return {
        ...state,
        types: {
          ...state.types,
          loading: false,
        },
      };
    case Types.GET_LOCAL_REQUEST:
      return {
        ...state,
        locals: {
          ...state.locals,
          loading: true,
        },
      };
    case Types.GET_LOCAL_SUCCESS:
      return {
        ...state,
        locals: {
          ...state.locals,
          data: action.payload.locals.data,
          loading: false,
        },
      };
    case Types.GET_LOCAL_FAILURE:
      return {
        ...state,
        locals: {
          ...state.locals,
          loading: false,
        },
      };
    case Types.GET_STORES_REQUEST:
      return {
        ...state,
        stores: {
          ...state.stores,
          loading: true,
        },
      };
    case Types.GET_STORES_SUCCESS:
      return {
        ...state,
        stores: {
          ...state.stores,
          loading: false,
          data: action.payload.stores.data,
        },
      };
    case Types.GET_STORES_FAILURE:
      return {
        ...state,
        stores: {
          ...state.stores,
          loading: false,
        },
      };
    case Types.GET_PASSIONS_REQUEST:
      return {
        ...state,
        passions: {
          ...state.passions,
          loading: true,
        },
      };
    case Types.GET_PASSIONS_SUCCESS:
      return {
        ...state,
        passions: {
          ...state.passions,
          data: action.payload.passions.data,
          loading: false,
        },
      };
    case Types.GET_PASSIONS_FAILURE:
      return {
        ...state,
        passions: {
          ...state.passions,
          loading: false,
        },
      };
    case Types.GET_DIFFICULTIES_REQUEST:
      return {
        ...state,
        difficulties: {
          ...state.difficulties,
          loading: true,
        },
      };
    case Types.GET_DIFFICULTIES_SUCCESS:
      return {
        ...state,
        difficulties: {
          ...state.difficulties,
          data: action.payload.difficulties.data,
          loading: false,
        },
      };
    case Types.GET_DIFFICULTIES_FAILURE:
      return {
        ...state,
        difficulties: {
          ...state.difficulties,
          loading: false,
        },
      };
    case Types.GET_PLANS_REQUEST:
      return {
        ...state,
        plans: {
          ...state.plans,
          loading: true,
        },
      };
    case Types.GET_PLANS_SUCCESS:
      return {
        ...state,
        plans: {
          ...state.plans,
          data: action.payload.plans.data,
          loading: false,
        },
      };
    case Types.GET_PLANS_FAILURE:
      return {
        ...state,
        plans: {
          ...state.plans,
          loading: false,
        },
      };
    case Types.APPROVE_REQUEST:
      return {
        ...state,
        approve: {
          ...state.approve,
          loading: true,
        },
      };
    case Types.APPROVE_SUCCESS:
    case Types.APPROVE_FAILURE:
      return {
        ...state,
        approve: {
          ...state.approve,
          loading: false,
        },
      };
    case Types.REPPROVE_REQUEST:
      return {
        ...state,
        repprove: {
          ...state.repprove,
          loading: true,
        },
      };
    case Types.REPPROVE_SUCCESS:
    case Types.REPPROVE_FAILURE:
      return {
        ...state,
        repprove: {
          ...state.repprove,
          loading: false,
        },
      };
    case Types.INVITE_REQUEST:
      return {
        ...state,
        invite: {
          ...state.invite,
          loading: true,
        },
      };
    case Types.INVITE_SUCCESS:
    case Types.INVITE_FAILURE:
      return {
        ...state,
        invite: {
          ...state.invite,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getEventRequest: id => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getEventSuccess: event => ({
    type: Types.GET_SUCCESS,
    payload: { event },
  }),

  getEventFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getEventsRequest: (page = 1, filters = null) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page, filters },
  }),

  getEventsSuccess: events => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { events },
  }),

  getEventsFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  createEventRequest: data => ({
    type: Types.CREATE_REQUEST,
    payload: { data },
  }),

  createEventSuccess: () => ({
    type: Types.CREATE_SUCCESS,
  }),

  createEventFailure: () => ({
    type: Types.CREATE_FAILURE,
  }),

  updateEventRequest: (id, data) => ({
    type: Types.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updateEventSuccess: () => ({
    type: Types.UPDATE_SUCCESS,
  }),

  updateEventFailure: () => ({
    type: Types.UPDATE_FAILURE,
  }),

  getEventsTypesRequest: () => ({
    type: Types.GET_TYPES_REQUEST,
  }),

  getEventsTypesSuccess: types => ({
    type: Types.GET_TYPES_SUCCESS,
    payload: { types },
  }),

  getEventsTypesFailure: () => ({
    type: Types.GET_TYPES_FAILURE,
  }),

  getEventsLocalRequest: (query = '') => ({
    type: Types.GET_LOCAL_REQUEST,
    payload: { query },
  }),

  getEventsLocalSuccess: locals => ({
    type: Types.GET_LOCAL_SUCCESS,
    payload: { locals },
  }),

  getEventsLocalFailure: () => ({
    type: Types.GET_LOCAL_FAILURE,
  }),

  getEventStoresRequest: (query = '') => ({
    type: Types.GET_STORES_REQUEST,
    payload: { query },
  }),

  getEventStoresSuccess: stores => ({
    type: Types.GET_STORES_SUCCESS,
    payload: { stores },
  }),

  getEventStoresFailure: () => ({
    type: Types.GET_STORES_FAILURE,
  }),

  getEventPassionsRequest: (query = '') => ({
    type: Types.GET_PASSIONS_REQUEST,
    payload: { query },
  }),

  getEventPassionsSuccess: passions => ({
    type: Types.GET_PASSIONS_SUCCESS,
    payload: { passions },
  }),

  getEventPassionsFailure: () => ({
    type: Types.GET_PASSIONS_FAILURE,
  }),

  getEventDifficultiesRequest: (query = '') => ({
    type: Types.GET_DIFFICULTIES_REQUEST,
    payload: { query },
  }),

  getEventDifficultiesSuccess: difficulties => ({
    type: Types.GET_DIFFICULTIES_SUCCESS,
    payload: { difficulties },
  }),

  getEventDifficultiesFailure: () => ({
    type: Types.GET_DIFFICULTIES_FAILURE,
  }),

  getEventsPlansRequest: () => ({
    type: Types.GET_PLANS_REQUEST,
  }),

  getEventsPlansSuccess: plans => ({
    type: Types.GET_PLANS_SUCCESS,
    payload: { plans },
  }),

  getEventsPlansFailure: () => ({
    type: Types.GET_PLANS_FAILURE,
  }),

  approveEventRequest: id => ({
    type: Types.APPROVE_REQUEST,
    payload: { id },
  }),

  approveEventSuccess: () => ({
    type: Types.APPROVE_SUCCESS,
  }),

  approveEventFailure: () => ({
    type: Types.APPROVE_FAILURE,
  }),

  repproveEventRequest: (id, data) => ({
    type: Types.REPPROVE_REQUEST,
    payload: { id, data },
  }),

  repproveEventSuccess: () => ({
    type: Types.REPPROVE_SUCCESS,
  }),

  repproveEventFailure: () => ({
    type: Types.REPPROVE_FAILURE,
  }),

  inviteEventRequest: (id, data) => ({
    type: Types.INVITE_REQUEST,
    payload: { id, data },
  }),

  inviteEventSuccess: () => ({
    type: Types.INVITE_SUCCESS,
  }),

  inviteEventFailure: () => ({
    type: Types.INVITE_FAILURE,
  }),

  // deleteEventRequest: id => ({
  //   type: Types.DELETE_REQUEST,
  //   payload: {
  //     id
  //   },
  // }),

  // deleteEventSuccess: () => ({
  //   type: Types.DELETE_SUCCESS,
  // }),

  // deleteEventFailure: () => ({
  //   type: Types.DELETE_FAILURE,
  // }),
};

const getStatus = benefit => {
  if (moment().isAfter(benefit.attributes.date_end)) {
    return { label: 'Expirado', className: 'label-inactive' };
  }

  switch (benefit.attributes.event_status) {
    case 'approve':
      return { label: 'Aprovado', className: 'label-active' };
    case 'reproved':
      return { label: 'Reprovado', className: 'label-inactive' };
    default:
      return { label: 'Pendente', className: 'label-pendent' };
  }
};

export const Selectors = {
  events: createSelector(
    state => state,
    events =>
      events.map(event => ({
        ...event,
        attributes: {
          ...event.attributes,
          date: moment(event.attributes.date).format('DD/MM/YYYY [às] HH:mm'),
          status: getStatus(event),
        },
      })),
  ),

  detail: createSelector(
    state => state,
    event =>
      event.id && {
        ...event,
        attributes: {
          ...event.attributes,
          canInvite:
            event.attributes.active &&
            event.attributes.event_status === 'approve' &&
            !!event.attributes.available_vacancies &&
            moment().isBefore(event.attributes.date_end),
          experience_plan_ids: event.attributes.plans.map(plan => ({ value: plan.id, label: plan.name })),
        },
      },
  ),

  locals: createSelector(
    state => state,
    locals => locals.map(local => ({ value: local.id, label: local.attributes.name })),
  ),

  stores: createSelector(
    state => state,
    stores => stores.map(store => ({ value: store.id, label: store.attributes.name })),
  ),

  difficulties: createSelector(
    state => state,
    difficulties => difficulties.map(local => ({ value: local.id, label: local.attributes.name })),
  ),

  plans: createSelector(
    state => state,
    plans => plans.map(local => ({ value: local.id, label: local.attributes.name })),
  ),

  types: createSelector(
    state => state,
    types => types.map(type => ({ value: type.id, label: type.attributes.name })),
  ),

  passions: createSelector(
    state => state,
    passions => passions.map(passion => ({ value: passion.id, label: passion.attributes.title })),
  ),
};
